<div class="micro-test-generator-container">
  <div class="micro-test-generator-body p-1">
    <!-- HEADER CON PULSANTI DI AZIONE -->
    <div class="test-header d-flex justify-content-between align-items-center mb-1">
      <div>
        <span class="small text-muted fst-italic" *ngIf="testCount === 0 && consolidatedTestsForDisplay.length === 0 && !isGeneratingTests">
          Click <i class="fa fa-flask mx-1"></i> to generate tests.
        </span>
        <span class="small text-muted" *ngIf="isGeneratingTests">
          <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span> Generating...
        </span>
      </div>

      <div class="test-actions d-flex align-items-center gap-1">
        <button type="button" class="btn btn-minimal" *ngIf="rawTestsForDisplay.length > 0 || consolidatedTestsForDisplay.length > 0" (click)="openFullScreenModal()" [disabled]="isEditModalVisible" title="Open in full screen">
          <i class="fa fa-fw fa-expand"></i>
        </button>
        <button type="button" class="btn btn-minimal" *ngIf="rawTestsForDisplay.length > 0 && hasAnySubTables()" (click)="toggleAllSubTables()" [disabled]="isEditModalVisible" title="{{ allSubTablesExpanded ? 'Hide Sub-Details' : 'Show Sub-Details' }}">
          <i class="fa fa-fw" [ngClass]="allSubTablesExpanded ? 'fa-compress-arrows-alt' : 'fa-expand-arrows-alt'"></i>
        </button>
        <button type="button" class="btn btn-minimal" *ngIf="canEditTests()" (click)="openEditModal()" title="Edit these tests in a modal">
          <i class="fa fa-fw fa-edit"></i>
        </button>
        <button type="button" class="btn btn-minimal btn-generate" (click)="onGenerateTestsButtonClick()" [disabled]="isGeneratingTests || isEditModalVisible" title="Generate Tests for this Detail">
          <span *ngIf="isGeneratingTests; else generateIcon" class="spinner-border spinner-border-xs" role="status" aria-hidden="true"></span>
          <ng-template #generateIcon><i class="fa fa-flask"></i></ng-template>
        </button>
        <button type="button" class="btn btn-minimal text-danger" *ngIf="rawTestsForDisplay.length > 0 && !microScenarioSpec?.isDuplicateContent" [disabled]="isEditModalVisible" (click)="clearGeneratedTests()" title="Clear these tests">
          <i class="fa fa-times"></i>
        </button>
      </div>
    </div>

    <!-- 1. SEZIONE PER I TEST CONSOLIDATI (TITOLO + TABELLA) -->
    <div *ngIf="consolidatedTestsForDisplay.length > 0" class="consolidated-section mb-3">
      <h6 class="mb-1 small fw-bold text-success d-flex align-items-center">
        <i class="fa fa-check-double me-2"></i>
        <span>Final Consolidated Tests</span>
      </h6>
      <div class="table-responsive resizable-container" style="font-size: 0.78rem; max-height: 250px; overflow-y: auto; min-height: 150px; resize: vertical; border: 1px solid #dee2e6;">
        <table class="table table-sm table-bordered table-hover micro-test-table-compact">
          <thead class="table-light" style="position: sticky; top: 0; z-index: 1;">
          <tr>
            <th *ngFor="let column of consolidatedColumns" class="py-1 px-2 small fw-normal">
              {{ column | titlecase }}
            </th>
          </tr>
          </thead>
          <tbody>
          <!-- 'test' is TestWithMetadata; its metadata now has the correct global ID -->
          <tr *ngFor="let test of consolidatedTestsForDisplay; let i = index">
            <td *ngFor="let column of consolidatedColumns" class="py-1 px-2">
              <!-- ID Column: THIS IS ALREADY CORRECT and will now display the global ID -->
              <span *ngIf="column.toUpperCase() === 'ID'">{{ test.metadata.sequentialId }}</span>

              <!-- Other Columns: Access data via test.data -->
              <ng-container *ngIf="column.toUpperCase() !== 'ID'">
                <ul *ngIf="isArray(test.data[column]) && test.data[column].length > 0" class="cell-list">
                  <li *ngFor="let item of test.data[column]">{{ item | stripHtml }}</li>
                </ul>
                <span *ngIf="isArray(test.data[column]) && test.data[column].length === 0" class="empty-list">(empty list)</span>
                <span *ngIf="!isArray(test.data[column])">{{ test.data[column] | stripHtml }}</span>
              </ng-container>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- 2. SEZIONE PER I TEST GREZZI (TITOLO + TABELLA) -->
    <div *ngIf="rawTestsForDisplay.length > 0" class="raw-section">
      <h6 class="mb-1 small fw-bold text-primary d-flex align-items-center">
        <i class="fa fa-flask me-2"></i>
        <span *ngIf="consolidatedTestsForDisplay.length > 0">Original Raw Tests</span>
        <span *ngIf="consolidatedTestsForDisplay.length === 0">Generated Tests</span>
      </h6>
      <div class="table-responsive resizable-container mt-1" style="font-size: 0.78rem; max-height: 250px; overflow-y: auto; min-height: 150px; resize: vertical; border: 1px solid #dee2e6;">
        <table class="table table-sm table-bordered table-hover micro-test-table-compact">
          <thead class="table-light" style="position: sticky; top: 0; z-index: 1;">
          <tr>
            <th *ngFor="let column of rawTestsColumns" scope="col" class="py-1 px-2 small fw-normal">
              {{ column | titlecase }}
            </th>
          </tr>
          </thead>
          <tbody>
          <!-- 'test' is now the full TestWithMetadata object -->
          <tr *ngFor="let test of rawTestsForDisplay; let i = index; trackBy: trackByTestId" id="microTestRow-{{microScenarioSpec.id}}-{{i}}">
            <td *ngFor="let column of rawTestsColumns" class="py-1 px-2" [class.expanded-cell]="column.toUpperCase() !== 'ID' && isSubTable(test.data[column]) && allSubTablesExpanded">

              <!-- ID Column -->
              <ng-container *ngIf="column.toUpperCase() === 'ID'">
                <!-- THE FIX FOR RAW TESTS: Display the global sequentialId from metadata -->
                <span>{{ test.metadata.sequentialId }}</span>
              </ng-container>

              <!-- Other Columns with List and Sub-table Support -->
              <ng-container *ngIf="column.toUpperCase() !== 'ID'">
                <!-- THE FIX FOR OTHER COLUMNS: Must access via test.data -->
                <ng-container *ngIf="isSubTable(test.data[column])">
                    <span class="sub-table-summary text-muted fst-italic small" *ngIf="!allSubTablesExpanded">
                      ({{ getSubTableRowCount(test.data[column]) }} details)
                    </span>
                  <div [class.d-none]="!allSubTablesExpanded" class="sub-table-wrapper mt-1 mb-0">
                    <!-- Your existing sub-table logic would go here -->
                  </div>
                </ng-container>

                <ng-container *ngIf="!isSubTable(test.data[column]) && isArray(test.data[column])">
                  <ul *ngIf="test.data[column].length > 0" class="cell-list">
                    <li *ngFor="let item of test.data[column]">{{ item | stripHtml }}</li>
                  </ul>
                  <span *ngIf="test.data[column].length === 0" class="empty-list">(empty list)</span>
                </ng-container>

                <ng-container *ngIf="!isSubTable(test.data[column]) && !isArray(test.data[column])">
                  <span>{{ test.data[column] | stripHtml }}</span>
                </ng-container>
              </ng-container>

            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</div>

<!-- MODALS (No changes needed here) -->
<app-edit-tests-modal
  [isVisible]="isEditModalVisible"
  [testsToEdit]="testsForModal"
  [columnsForModal]="columnsForModalEditing"
  [microScenarioIdForContext]="getTrueOriginalIdForTestOperations()"
  (saveTests)="handleModalSave($event)"
  (closeModal)="handleModalClose()">
</app-edit-tests-modal>

<div class="modal fade" [class.show]="isFullScreenModalVisible" [style.display]="isFullScreenModalVisible ? 'block' : 'none'"
     tabindex="-1" role="dialog" aria-labelledby="fullScreenModalLabel" aria-hidden="true"
     (click)="onFullScreenModalBackdropClick($event)">
  <div class="modal-dialog modal-fullscreen" role="document">
    <div class="modal-content">
      <div class="modal-header border-bottom">
        <h5 class="modal-title" id="fullScreenModalLabel">
          <i class="fa fa-table me-2"></i>
          Test Tables - Full Screen View
        </h5>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeFullScreenModal()"></button>
      </div>
      <div class="modal-body p-0" style="overflow: hidden;">
        <div class="container-fluid h-100 p-3">
          <!-- Full-screen Consolidated Tests Section -->
          <div *ngIf="consolidatedTestsForDisplay.length > 0" class="mb-4">
            <h5 class="mb-3 text-success d-flex align-items-center">
              <i class="fa fa-check-double me-2"></i>
              Final Consolidated Tests
            </h5>
            <div class="table-responsive" style="max-height: 45vh; overflow-y: auto; border: 1px solid #dee2e6;">
              <table class="table table-striped table-hover">
                <thead class="table-success" style="position: sticky; top: 0; z-index: 1;">
                <tr>
                  <th *ngFor="let column of consolidatedColumns" class="py-2 px-3">{{ column | titlecase }}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let test of consolidatedTestsForDisplay; let i = index">
                  <td *ngFor="let column of consolidatedColumns" class="py-2 px-3">
                    <span *ngIf="column.toUpperCase() === 'ID'" class="badge bg-success">{{ test.metadata.sequentialId }}</span>
                    <ng-container *ngIf="column.toUpperCase() !== 'ID'">
                      <ul *ngIf="isArray(test.data[column]) && test.data[column].length > 0" class="mb-0">
                        <li *ngFor="let item of test.data[column]">{{ item | stripHtml }}</li>
                      </ul>
                      <span *ngIf="isArray(test.data[column]) && test.data[column].length === 0" class="text-muted fst-italic">(empty list)</span>
                      <span *ngIf="!isArray(test.data[column])">{{ test.data[column] | stripHtml }}</span>
                    </ng-container>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- Full-screen Raw Tests Section -->
          <div *ngIf="rawTestsForDisplay.length > 0">
            <h5 class="mb-3 text-primary d-flex align-items-center">
              <i class="fa fa-flask me-2"></i>
              <span *ngIf="consolidatedTestsForDisplay.length > 0">Original Raw Tests</span>
              <span *ngIf="consolidatedTestsForDisplay.length === 0">Generated Tests</span>
            </h5>
            <div class="table-responsive" [style.max-height]="consolidatedTestsForDisplay.length > 0 ? '45vh' : '80vh'" style="overflow-y: auto; border: 1px solid #dee2e6;">
              <table class="table table-striped table-hover">
                <thead class="table-primary" style="position: sticky; top: 0; z-index: 1;">
                <tr>
                  <th *ngFor="let column of rawTestsColumns" class="py-2 px-3">{{ column | titlecase }}</th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let test of rawTestsForDisplay; let i = index; trackBy: trackByTestId">
                  <td *ngFor="let column of rawTestsColumns" class="py-2 px-3">
                    <ng-container *ngIf="column.toUpperCase() === 'ID'">
                      <span class="badge bg-primary">{{ test.metadata.sequentialId }}</span>
                    </ng-container>
                    <ng-container *ngIf="column.toUpperCase() !== 'ID'">
                      <ng-container *ngIf="isSubTable(test.data[column])">
                        <div class="text-muted mb-2"><small><i class="fa fa-table me-1"></i>{{ getSubTableRowCount(test.data[column]) }} sub-items:</small></div>
                        <div class="sub-table-wrapper"><small class="text-info">[Sub-table content would be displayed here]</small></div>
                      </ng-container>
                      <ng-container *ngIf="!isSubTable(test.data[column]) && isArray(test.data[column])">
                        <ul *ngIf="test.data[column].length > 0" class="mb-0">
                          <li *ngFor="let item of test.data[column]">{{ item | stripHtml }}</li>
                        </ul>
                        <span *ngIf="test.data[column].length === 0" class="text-muted fst-italic">(empty list)</span>
                      </ng-container>
                      <ng-container *ngIf="!isSubTable(test.data[column]) && !isArray(test.data[column])">
                        <span>{{ test.data[column] | stripHtml }}</span>
                      </ng-container>
                    </ng-container>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal-backdrop fade" [class.show]="isFullScreenModalVisible" *ngIf="isFullScreenModalVisible"></div>
